import React, { useState } from 'react';

// Tela exibida após o cliente avaliar o atendimento: agradece e permite deixar
// um comentário adicional antes de voltar à tela inicial.
const ChatThankYou = ({ onSubmit, onSkip }) => {
  const [comment, setComment] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    setSending(true);
    try {
      await onSubmit((comment || '').trim());
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="chat-thankyou">
      <p className="chat-evaluation-title">Obrigado pela sua avaliação!</p>
      <p className="chat-thankyou-subtitle">
        Quer deixar um comentário sobre o atendimento? (opcional)
      </p>
      <textarea
        className="chat-thankyou-input"
        placeholder="Escreva um comentário..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={3}
        maxLength={500}
      />
      <div className="chat-evaluation" style={{ marginTop: '1rem' }}>
        <button
          type="button"
          className="chat-evaluation-button"
          onClick={onSkip}
          disabled={sending}
        >
          Pular
        </button>
        <button
          type="button"
          className="chat-evaluation-button"
          onClick={handleSend}
          disabled={sending || !comment.trim()}
        >
          {sending ? 'Enviando...' : 'Enviar comentário'}
        </button>
      </div>
    </div>
  );
};

export default ChatThankYou;
